<template>
  <a :download="downloadName" :href="downloadUrl" :disabled=" !this.data || this.data.length === 0">
    <slot>
      <i class="fa fa-file-excel-o" aria-hidden="true"></i>
    </slot>
  </a>
</template>

<script>
// import json2csv from 'json2csv'
export default {
  props: {
    fields: undefined,
    data: undefined,
    downloadName: {
      default: 'export.csv'
    }
  },
  computed: {
    downloadUrl() {
      if (!this.data) return 'javascript:void(0)'
      const items = this.simplifyData(this.data)
      const replacer = (key, value) => (value === null ? '' : value) // specify how you want to handle null values here
      const header = Object.keys(items[0])
      let csv = items.map(row =>
        header
          .map(fieldName => JSON.stringify(row[fieldName], replacer))
          .join(',')
      )
      csv.unshift(header.join(','))
      csv = csv.join('\r\n')
      return this.data.length > 0
        ? 'data:text/csv,' + encodeURIComponent(csv)
        : 'javascript:void(0);'
    }
  },
  methods: {
    simplifyData(data) {
      return data.map(c => {
        return {
          'First Name': c.FirstName,
          'Last Name': c.LastName,
          'Phone Numbers': c.PhoneNumbers.map(p => p.Number).join(' - '),
          'Email Addresses': c.EmailAddresses.map(e => e.Email).join(' - '),
          Address: c.Addresses.map(a => a.Address).join(' - '),
          Notes: c.Notes.map(n => n.Note).join(' - ')
        }
      })
    }
  }
}
</script>